import React from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'
import {
  Fab,
  IconButton,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'

import {
  mdiDelete,
  mdiPencil,
  mdiPlus,
} from '@mdi/js'

import AutomationEditDialog from './AutomationEditDialog'

const DEFAULT_AUTOMATION = {
  name: 'test',
  script: 'console.log("Hello, World!");',
  triggers: [],
  params: {},
}

class AutomationListView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    automations: PropTypes.object,
    unitId: PropTypes.number,
    onAdd: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
  }

  static defaultProps = {
    automations: {},
    unitId: undefined,
  }

  static styles = (theme) => ({
    table: {
      width: 'auto',
    },
    fab: {
      position: 'absolute',
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
  })

  state = {
    editingAutomation: null,
  }

  onCloseEdit = () => {
    this.setState({ editingAutomation: null })
  }

  onSave = (automation) => {
    this.onCloseEdit()
    if (automation.id) {
      this.props.onSave(automation)
    } else {
      this.props.onAdd(automation)
    }
  }

  onAddClick = () => {
    this.setState({ editingAutomation: DEFAULT_AUTOMATION })
  }

  onEditClick(id) {
    const { automations } = this.props
    this.setState({ editingAutomation: automations[id] })
  }

  onDeleteClick(id) {
    this.props.onDelete(id)
  }

  renderAutomation = (automation) => (
    <TableRow key={`${automation.id}`}>
      <TableCell size="small">
        {automation.id}
      </TableCell>
      <TableCell size="small">
        {automation.name}
      </TableCell>
      <TableCell padding="none">
        <IconButton aria-label="Edit" onClick={() => this.onEditClick(automation.id)}>
          <SvgIcon>
            <path d={mdiPencil} />
          </SvgIcon>
        </IconButton>
        <IconButton aria-label="Delete" onClick={() => this.onDeleteClick(automation.id)}>
          <SvgIcon>
            <path d={mdiDelete} />
          </SvgIcon>
        </IconButton>
      </TableCell>
    </TableRow>
  )

  render() {
    const { automations, unitId, classes } = this.props
    const { editingAutomation } = this.state

    const automationList = Object.values(automations)

    return (
      <div className={classes.root}>
        <Fab onClick={this.onAddClick} color="primary" className={classes.fab}>
          <SvgIcon>
            <path d={mdiPlus} />
          </SvgIcon>
        </Fab>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell size="small">
                ID
              </TableCell>
              <TableCell size="small">
                Name
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {automationList.map(this.renderAutomation)}
          </TableBody>
        </Table>

        { editingAutomation
          && (
            <AutomationEditDialog
              onSave={this.onSave}
              onClose={this.onCloseEdit}
              automation={editingAutomation}
              unitId={unitId}
            />
          )}
      </div>
    )
  }
}

export default withStyles(AutomationListView.styles)(AutomationListView)
